import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private auth: AuthenticationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isLoggedIn = this.auth.currentUserName$.value;
    const idToken = sessionStorage.getItem('id-token');
    if (isLoggedIn && idToken) {
      request = request.clone({ setHeaders: { Authorization: idToken } });
    }
    const localDev = typeof window !== 'undefined' && !window.location?.href?.includes('.com');
    const serverlessApi = /api\./.test(request.url);
    if (localDev && serverlessApi) {
      // Convert absolute API URLs to relative paths so ng-serve's proxy
      // (proxy.config.json) can match and forward them. Keep the full path
      // (including the /wgagents/ base) so the proxy entry matches.
      try {
        const u = new URL(request.url);
        request = request.clone({ url: `${u.pathname}${u.search}${u.hash}` });
      } catch {
        // Not a parseable absolute URL — leave it alone.
      }
    }
    return next.handle(request);
  }
}
